<template>
<div>
  <div style="display: flex;flex-direction: row;margin-bottom: 10px;">
    <el-button size="mini" @click="getList">查询</el-button>
    <el-button size="mini" v-if="customerOldId&&customerNewId" @click="setComponentsId('SaleCarryOverMain')">结转</el-button>
    <el-button size="mini" @click="hide">关闭</el-button>
  </div>
  <el-descriptions size="mini" :column="1" border direction="vertical">
    <el-descriptions-item label="应收款明细信息">
      <div>
        <el-descriptions size="mini" :label-style="{width: '80px'}" :column="1" border>
          <el-descriptions-item label="结转日期">
            <el-date-picker
              v-model="form.carry_forward_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <span style="color: #ff0000"> &nbsp;&nbsp;&nbsp;&nbsp;*&nbsp;&nbsp;结转时间必须选择（选择之日起即就是新客户的）</span>
          </el-descriptions-item>
<!--          <el-descriptions-item label="操作说明">-->
<!--            <p>1.费项结转，主要就是把费项结转给新客户！</p>-->
<!--            <p>2.【结转日期】请必须选择，否则无法进行结转！</p>-->
<!--            <p>3.【收费项】主要提供筛选出来对应的收费项，筛选出什么样的账单就结转什么样的费项！</p>-->
<!--            <p>4.【手动调整应收金额】就意味着放弃了系统自动划分新老客户应收款的配比！同时本费项自定义划分账单计费周期必须包含【结转日期】，否则设置无效！系统会自动把结转日期及结转日期后的费用结转给新客户！</p>-->
<!--            <p>5.【已缴部分金额】如果该账单在计费周期包含【结转日期】，设置了已缴款新老业主配比金额，系统会按照配置结转已缴金额，如果不设置，金额将划归老客户；如果计费周期不包含【结转日期】，即便设置也无效！</p>-->
<!--            <p>6.页面显示哪些费项就会按【结转日期】结转哪些费项，操作人员可以通过勾选移除对应的不需要结转的费项避开计费周期包含【结转日期】的费项进行结转！</p>-->
<!--          </el-descriptions-item>-->
        </el-descriptions>
      </div>
      <div style="width: 100%;display: grid;">
<!--        <el-table-->
<!--          v-if="pageData" v-loading="loading" :data="pageData.list"-->
<!--          border-->
<!--          @selection-change="handleSelectionChange"-->
<!--          style="width: 100%">-->
<!--          <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>-->
<!--          <el-table-column prop="house_name" label="房产" align="center" width="320"></el-table-column>-->
<!--          <el-table-column prop="carry_down_date" label="结转时间 " align="center" width="150"></el-table-column>-->
<!--          <el-table-column prop="now_customer_name" label="老客户" align="center" width="100">-->
<!--            <template slot-scope="scope">-->
<!--              <el-link type="primary" @click="showEditor(scope.row.now_customer_id)">{{scope.row.now_customer_name}}</el-link>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="new_customer_name" label="新客户" align="center" width="100">-->
<!--            <template slot-scope="scope">-->
<!--              <el-link type="primary" @click="showEditor(scope.row.new_customer_id)">{{scope.row.new_customer_name}}</el-link>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="startDate" label="状态" align="center" width="100">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.status==1" style="color: #42a936;font-weight: bold;">可撤销</span>-->
<!--              <span v-if="scope.row.status==2" style="color: #ff3d00;font-weight: bold;">不可操作</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="create_user_name" label="创建人" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="create_time" label="创建时间" align="center" width="150"></el-table-column>-->
<!--          <el-table-column prop="update_user_name" label="修改人" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="update_time" label="修改时间" align="center" width="150"></el-table-column>-->
<!--          <el-table-column prop="startDate" label="操作" width="200">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button @click="showOrder(scope.row)">详情</el-button>-->
<!--              <el-button v-if="scope.row.status==1" @click="backOrder(scope.row.id)">撤销</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->


        <el-table
          v-if="pageData" v-loading="loading" :data="pageData.list"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
          <el-table-column prop="ancestor_name" label="房产" align="center" width="320"></el-table-column>
          <el-table-column prop="SplitData" label="结转时间 " align="center" width="150"></el-table-column>
          <el-table-column prop="now_customer_name" label="老客户" align="center" width="100">
            <template slot-scope="scope">
              <el-link type="primary" @click="showEditor(scope.row.CustomerAgedId)">{{scope.row.CustomerAgedName}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="new_customer_name" label="新客户" align="center" width="100">
            <template slot-scope="scope">
              <el-link type="primary" @click="showEditor(scope.row.CustomerNewId)">{{scope.row.CustomerNewName}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="startDate" label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.state==1" style="color: #42a936;font-weight: bold;">可撤销</span>
              <span v-if="scope.row.state==2" style="color: #ff3d00;font-weight: bold;">不可操作</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="操作时间" align="center" width="150"></el-table-column>
          <el-table-column prop="name" label="结转人" align="center" width="100"></el-table-column>
          <el-table-column prop="name1" label="撤销人" align="center" width="100"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
<!--              <el-button @click="showOrder(scope.row)">详情</el-button>-->
              <el-button v-if="scope.row.state==1" @click="backOrder(scope.row.number)">撤销</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </el-descriptions-item>
  </el-descriptions>

  <el-dialog
    :visible.sync="dialogVisible"
    width="90vw">

    <SaleCarryOverDetails v-if="dialogVisible" :customerOldId="show_item.now_customer_id" :customerNewId="show_item.new_customer_id" :houseId="show_item.house_id" :Id="show_item.id" />

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>

  <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" @callback="editorCallback" />
</div>
</template>

<script>
import Editor from "../../../Customer/editor";
import moment from "moment";
import SaleCarryOverDetails from "./SaleCarryOverDetails";

export default {
  name: "SaleCarryOverList",
  components:{SaleCarryOverDetails, Editor},
  inject:['setComponents','onEventHandel'],
  props:{
    customerOldId:[Number,String],
    customerNewId:[Number,String],
    houseId:[Number,String]
  },
  data(){
    return{
      loading:false,
      form:{
        carry_forward_date:""
      },
      multipleSelection:[],
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      editor:{
        classValue:1,
        id:0,
        visable:false
      },
      dialogVisible:false,
      show_item:{}
    }
  },
  activated() {
    const that=this;
    that.house_id=that.houseId;
    that.multipleSelection=[];
    that.pageChange(1);
  },
  watch:{
    houseId(n,o){
      const that=this;
      that.house_id=n;
      that.multipleSelection=[];
      that.pageChange(1);
    },
  },
  methods:{
    getList(){
      const that=this;
      that.loading=true;
      ERP.postRequest({url: "admin/UserOrderSplit/SplitList", data: {
          house_id:that.house_id,
          pageSize:that.pageData.pageSize,
          page:that.pageData.page,
        }
      }, res => {
        if (res.code==200) {
          // console.log(res.data);
          // res.data.list.map(ret=>{
          //   ret.checkbox=false;
          //   ret.old_money="";
          //   ret.new_money="";
          //   // ret.PaidChargeSum="100";
          //   ret.old_PaidChargeSum=ret.PaidChargeSum;
          //   ret.new_PaidChargeSum="";
          //   return ret;
          // })
          that.pageData.list=res.data
        }
        that.loading=false;
      })
      // ERP.postRequest({url: "admin/UserOrderSplit/SplitList", data: {
      //     house_id:that.house_id,
      //     pageSize:that.pageData.pageSize,
      //     page:that.pageData.page,
      //   }
      // }, res => {
      //   if (res.code) {
      //     // console.log(res.data);
      //     res.data.list.map(ret=>{
      //       ret.checkbox=false;
      //       ret.old_money="";
      //       ret.new_money="";
      //       // ret.PaidChargeSum="100";
      //       ret.old_PaidChargeSum=ret.PaidChargeSum;
      //       ret.new_PaidChargeSum="";
      //       return ret;
      //     })
      //     that.pageData=res.data
      //   }
      //   that.loading=false;
      // })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    search(){
      const that=this;
      that.multipleSelection=[];
      that.pageChange(0)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    showEditor(customer_id) {
      const that=this;
      that.getCustomerBase(customer_id,data=>{
        that.editor.classValue = data.class
        that.editor.id = customer_id
        that.editor.visable = true
      })
    },
    getCustomerBase(customer_id,callback){
      ERP.getRequest({
        url: "admin/Customer/getCustomerBase",
        data: {
          id: customer_id,
        }
      }, res => {
        if (res.code) {
          typeof callback ==="function"&&callback(res.data);
        }
      })
    },
    editorCallback(arg) {
      // this.getList()
      if(arg && arg[0]) this.editor.id = arg[0]
    },
    setComponentsId(componentsId){
      this.setComponents(componentsId)
    },
    backOrder(id){
      const that=this;
      that.$confirm('请在撤销请先确认还原会的操作日期是否正确！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.postRequest({url: "admin/UserOrderSplit/Restore", data: {
            number:id,
          }
        }, res => {
          if (res.code==200) {
            that.$message.success("撤销成功")
            that.getList();
          }else {
            that.$message.error(res.message||"撤销异常")
          }
        })

        // ERP.postRequest({url: "admin/SaleCarryOver/backOrder", data: {
        //     id:id,
        //   }
        // }, res => {
        //   if (res.code) {
        //     that.$message.success("撤销成功")
        //     that.getList();
        //   }else {
        //     that.$message.error(res.msg||"撤销异常")
        //   }
        // })
      }).catch(() => {

      });
    },
    showOrder(item){
      const that=this;
      that.show_item=item
      that.dialogVisible=true;
    },
    hide(){
      this.onEventHandel("SaleCarryOverMain",'hide')
    },
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
.pagination-wrap{
  margin-top: 10px;
  text-align: center;
}
//>>>.el-table--border, .el-table--group{
//  border: 1px solid #000000;
//}
//>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
//  border-bottom: 1px solid #000000;
//}
//>>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
//  border-right: 1px solid #000000;
//}
//>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
//  border-bottom: 1px solid #000000;
//}
//>>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
//  border-bottom: 1px solid #000000;
//}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/SaleCarryOverList.vue